import { render, staticRenderFns } from "./RuleNameStep.vue?vue&type=template&id=465ae8e0&scoped=true&"
import script from "./RuleNameStep.vue?vue&type=script&lang=js&"
export * from "./RuleNameStep.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "465ae8e0",
  null
  
)

export default component.exports